import { isEmpty } from 'lodash';

const getDailyLogResponse = (response) => {
  if (isEmpty(response?.activityLog)) return [];

  const result = response?.activityLog?.map((item) => {
    const durationMin = item?.durationMin ?? undefined;
    const durationSecond = item?.durationSecond ?? undefined;

    const duration = durationMin >= 0 && durationSecond >= 0 ? `${durationMin} menit ${durationSecond} detik` : '';

    return {
      ...item,
      duration,
    };
  });

  return result;
};

export default getDailyLogResponse;
